import { render, staticRenderFns } from "./ProduceController.vue?vue&type=template&id=524ef24d&"
import script from "./ProduceController.vue?vue&type=script&lang=ts&"
export * from "./ProduceController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports